const search = typeof window.self !== 'undefined' ? window.self.location?.search ?? '' : '';

export const query = new URLSearchParams(search);
